import React, { useState } from "react";
import { Link } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-9" >
                    <div style={{ paddingLeft: "5%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{ display: 'flex',alignItems:'center',justifyContent:'center' }}>
                            <div className="logo-image" >
                                <img src="./images/logo.png" style={{ width: "40%" }} alt="logo" />
                            </div>
                            <div style={{ float: 'left', display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'center',marginLeft:'-40px' }}>
                                <span className="templename">
                                    Kodimoottil Devi Temple
                                </span>
                                <span className="templename">
                                    കൊടിമൂട്ടിൽ ശ്രീ ഭദ്രകാളീ ക്ഷേത്രം
                                </span>
                            </div>
                        </div>



                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-3 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Home
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                                History
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.kodimoottildevi.org"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                                Darsan Time
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Utsavam" className="menuitems" onClick={closeMenu}>
                                Utsavam
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                                Administration
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                                Gallery
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default MainMenu;
